import request from '@utils/request';
import ApiHost from '@services/api-config';
import { AxiosPromise } from 'axios';
type UserInfo = {
	[propName: string]: string | number | boolean | { [propName: string]: string | number | undefined };
};

export interface ICoursesData {
	/* 上课方式, 1: zoom, 2: airclass */
	classMode?: number;

	/* 课程时长（分钟） */
	duration?: number;

	/* 是否有课件 */
	existCourseware?: boolean;

	/* 是否有课程报告 */
	existReport?: boolean;

	/* 课程结束时间(实际), Date类型时间戳 	string($date-time) example: 1628478900000 */
	lessonEndAt?: string;

	/* 课程结束时间, Date类型时间戳 	string($date-time) example: 1628478900000 */
	lessonEndTime?: string;

	/* 课程开始时间, Date类型时间戳 	string($date-time) example: 1628478900000 */
	lessonStartTime?: string;

	/* 课程id */
	lessonId?: number;

	/* 科目名称 */
	lessonSubjectName?: string;

	/* 课程名称 */
	lessonName?: string;

	/* 课程类型 1、测评课 2、正式课 3、调试课 */
	lessonType?: number;

	/* 课程状态（0.待上课 1.待上课（可进入教室（课前20分钟内）; 2.上课中 3.已上课 4未上课 5.已取消） */
	//  0 1 2 归类未完成列表 3 4 归类为已完成列表
	state: number;

	/* 老师信息 */
	teacher?: {
		/* 老师姓名 */
		name?: string;
	};
	/* zoom课程信息 */
	zoomInfo?: {
		zoomLink?: string; // 学生的
		zoomSellerLink?: string; // 销售
		zoomTeacherLink?: string; // 老师
	};

	/* 自定义属性 年月字符串 */
	customDateStr?: string;
}
export interface IPackageData {
	id?: string;
	packageName?: string;
	payType?: string;
	courseLevel?: string;
	grades?: any;
	classes?: string;
	hours?: string;
	currCharacter?: string;
	price?: string;
	originPrice?: string;
}
export interface IPreOrderData {
	discountAmount?: string;
	freeSession?: string;
	paidAmount?: string;
} 
export interface IEchoData {
	packageName?: string;
	payType?: string;
	classes?: string;
	hours?: string;
}
export interface ICreateOrderData {
	amount?: string;
}
interface ILessonCardList {
	lessonCardList?: ICoursesData[];
}
interface IPackagesList {
	IPackagesList?: IPackageData[];
} 
interface IPreOrder {
	IPreOrder?: IPreOrderData[];
}
interface ICreateOrder {
	ICreateOrder?: ICreateOrderData[];
}

export const updateUserInfo = (data: UserInfo): AxiosPromise<RequestResponse<boolean>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/user/update/baseInfo`,
		data,
	});
};

export const getOrderData = (data: { pageNo: number; pageSize: number }): AxiosPromise<RequestResponse<any>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/order`,
		data,
	});
};

export const getPayUrl = (data: {
	orderNo: string | undefined;
	orderPaymentNo: string | undefined;
}): AxiosPromise<RequestResponse<string>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/order/get/pay/url`,
		data,
	});
};
/* 获取课时包 */
export const getPackages = (data: {
	pageNo: number;
	pageSize: number;
}): AxiosPromise<RequestResponse<IPackagesList>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/lesson/getPackages`,
		data,
	});
};
/* 预创建订单 */
export const preOrder = (data: {
	productDTOList: [];
}): AxiosPromise<RequestResponse<IPreOrder>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/order/packages/preOrder`,
		data,
	});
};
/* 创建订单 */
export const createOrder = (data: {
	amount: string;
	productDTOList: [];
}): AxiosPromise<RequestResponse<ICreateOrder>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/order/packages/createOrder`,
		data,
	});
};

/* 获取待上课程/已上课信息 */
export const getCourses = (data: {
	pageNo: number;
	pageSize: number;
	lessonState: number; // 0 待上课 1 已上课
}): AxiosPromise<RequestResponse<ILessonCardList>> => {
	return request({
		method: 'post',
		url: `${ApiHost.airGateway}/air-student-ow-api/api/lesson/getLessonCards`,
		data,
	});
};

/**
 * 获取trustpilot值
 */
export function getTrustpilot() {
	return request({
		method: 'get',
		url: `${ApiHost.airGateway}/ac-ops-third-api/api/trust/score`,
	});
}
